import { render } from "./EditUserDialog.vue?vue&type=template&id=5022bccf&scoped=true"
import script from "./EditUserDialog.vue?vue&type=script&lang=js"
export * from "./EditUserDialog.vue?vue&type=script&lang=js"

import "./EditUserDialog.vue?vue&type=style&index=0&id=5022bccf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5022bccf"]])

export default __exports__